// extracted by mini-css-extract-plugin
export default {"pagination-main":"Pagination_pagination-main__YfzfO","page":"Pagination_page__tJXk6","activePage":"Pagination_activePage__AAm2h"};